import { ABP, ListService, PagedResultDto, TrackByService } from '@abp/ng.core';
import { DateAdapter } from '@abp/ng.theme.shared/extensions';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';

import { AssetService } from '../../../../proxy/assets';
import { AssetDto, AssetWithNavigationPropertiesDto, GetAssetsInput } from '../../../../proxy/assets/models';
import { AssetWithNavigationPropertiesDtoEmpty } from '../../../../proxy/assets/emptys-dto';
import { AssetEventComponent } from '../../../../asset-events/asset-event/components/asset-event.component';

@Component({
  selector: 'app-asset-details',
  providers: [ListService, { provide: NgbDateAdapter, useClass: DateAdapter }],
  templateUrl: './asset-details.component.html',
  styleUrls: ['./asset-details.component.scss']
})
export class AssetDetailsComponent implements OnInit {
  isAssetInfoHidden = true;

  asset: AssetWithNavigationPropertiesDto;

  @ViewChild(AssetEventComponent) assetEventComponent: AssetEventComponent;

  constructor(
    public readonly list: ListService,
    public readonly track: TrackByService,
    public readonly service: AssetService,
    private route: ActivatedRoute,
  ) {
    this.asset = new AssetWithNavigationPropertiesDtoEmpty;
  }

  ngOnInit(): void {
    var assetId = this.route.snapshot.paramMap.get('id');
    this.service.getWithNavigationProperties(assetId).subscribe(result => this.loadAsset(result));
  }

  loadAsset(asset: AssetWithNavigationPropertiesDto){
    this.asset = asset;
    this.assetEventComponent.setAsset(asset);
  }

}
